import EmailFlowDashboard from 'components/powerEmailFlow/containers/powerEmailFlow';

export const SettingsEmailEditFlowView = EmailFlowDashboard;
